/** setup 컨텍스트 밖(store·비동기 handler)에서 i18n t() 사용 */
export const appT = (key: string, params?: Record<string, unknown>) => {
  try {
    const nuxtApp = useNuxtApp();
    // @nuxtjs/i18n v9: $i18n 은 Composer — t()가 직접 있음 (.global 없음)
    // 앱 cold start 시 $i18n 미준비일 수 있음 → 키 반환 (크래시 방지)
    const i18n = nuxtApp?.$i18n as
      | { t?: (key: string, params?: Record<string, unknown>) => string }
      | undefined;
    if (typeof i18n?.t !== 'function') return key;
    return i18n.t(key, params ?? {});
  } catch {
    return key;
  }
};
